<template>
  <el-form ref="judgmentForm" :inline="false" :model="specialProponentJudgment"
    label-width="190px" label-position="right">
    <!-- Άν η αίτηση έρχεται από εκτελεστική επιτροπή -->
    <div v-if="showFrοmBoard">
      <el-form-item label="Αποφάσεις Μελών Επιτροπής:">
        <el-table :data="boardJudgement" style="width: 100%">
          <el-table-column label="Όνομα"  width="100">
            <template slot-scope="scope">
              <span>{{ scope.row.firstname }}</span>
            </template>
          </el-table-column>
          <el-table-column label="Επώνυμο"  width="100">
            <template slot-scope="scope">
              <span>{{ scope.row.surname }}</span>
            </template>
          </el-table-column>
          <el-table-column label="Αποδοχή πρότασης" align="center">
            <el-table-column label="Εισηγητή"  width="90" align="center">
              <template slot-scope="scope">
                <span class="agree-btn" v-if="scope.row.agreeWithProponent === true">
                  <i class="el-icon-check"></i>
                </span>
                <span class="disagree-btn" v-if="scope.row.agreeWithProponent === false">
                  <i class="el-icon-close"></i>
                </span>
                <span class="pending-btn" v-if="scope.row.agreeWithProponent === null">
                  <i class="el-icon-minus"></i>
                </span>
              </template>
            </el-table-column>
            <el-table-column label="Ακαδημαικού Συμβούλου"  width="110" v-if='fromConsultant' align="center">
              <template slot-scope="scope">
                <span class="agree-btn" v-if="scope.row.agreeWithAC === true">
                  <i class="el-icon-check"></i>
                </span>
                <span class="disagree-btn" v-if="scope.row.agreeWithAC === false">
                  <i class="el-icon-close"></i>
                <span class="pending-btn" v-if="scope.row.agreeWithAC === null">
                  <i class="el-icon-minus"></i>
                </span>
                </span>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="Εισήγηση">
            <template slot-scope="scope">
              <span>{{ scope.row.proposal }}</span>
            </template>
          </el-table-column>
          <el-table-column label="Υποβολή"  width="85" align="center">
            <template slot-scope="scope">
              <span class="done-btn" v-if="scope.row.finalize === true">
                <i class="el-icon-check"></i>
              </span>
              <span class="pending-btn" v-if="scope.row.finalize === false">
                <i class="el-icon-edit"></i>
              </span>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
      <!-- Αν η αίτηση έχει περάσει από ακαδημαϊκό σύμβουλο -->
      <div v-if="showFromAC">
        <el-form-item label="Aκαδημαϊκός σύμβουλος:">
          {{consultantName}}
        </el-form-item>
        <el-form-item label="Εισήγηση Ακαδημαϊκού:">
           {{consultantJudgement}}
        </el-form-item>
      </div>
    </div>
    <!-- Αν η αίτηση έρχεται από πρόεδρο -->
    <div v-if="showFromPresident || showFromPrechecker">
      <el-form-item label="Ακαδ. περιοχή" size="small">
        {{ academicFieldName }}
      </el-form-item><br>
      <!-- <el-form-item label="Σχόλιο προέδρου" size="small">
        {{presidentComment}}
      </el-form-item> -->
    </div>
    <el-form-item v-if="isReappraisal && this.workingApplication.overdue">
      <el-alert :closable="false" type="warning" :title="OVERDUE_MESSAGE" show-icon=""
        style="border: 1px solid; background-color: #fdf6ec;"></el-alert>
    </el-form-item>
    <br v-if="isReappraisal && this.workingApplication.overdue"/>
    <el-form-item :label="gradeLabel()" v-if="!isReappraisal" class="compact-form-item">
      <el-input placeholder="Παρακαλώ εισάγετε βαθμό"  maxlength="4" v-model="application.grade"></el-input>
    </el-form-item>
    <el-form-item v-if="!isReappraisal" :label="gradeDescriptionLabel()"
      class="compact-form-item">
      {{ application.grade_description }}
    </el-form-item>
    <el-form-item label="Τίτλος Σπουδών" v-if="!isReappraisal && !isPostExam">
      <el-input placeholder="Παρακαλώ εισάγετε τον Τίτλο Σπουδών" v-model="application.certificationTitleByInternal"
        style="width: 600px;" maxlength="255"></el-input>
    </el-form-item>
    <el-form-item label="Τίτλος Σπουδών (Συνυποβολή)" v-if="!isReappraisal && !isPostExam && application.titles.titleConsideration"
      class="compact-form-item">
      <el-input placeholder="Παρακαλώ εισάγετε τον Συνυποβαλλόμενο Τίτλο Σπουδών" v-model="application.considerationTitleByInternal"
        style="width: 600px;" maxlength="255"></el-input>
    </el-form-item>
    <hr v-if="!isReappraisal">
    <!-- Στοιχεια ιδρύματος-κολλεγίου-σχολής-τμήματος -->
    <table v-if="!isReappraisal && !isPostExam">
      <tr>
        <th>Τίτλος προς αναγνώριση</th>
        <th v-if="application.titles.titleConsideration">Συνυποβαλλόμενος τίτλος</th>
      </tr>
      <tr>
        <td>
          <el-form-item label="Πανεπιστήμιο" size="small">
            {{application.titles.university.name}}
            <el-alert
              :closable='false'
              v-if="uniAccredited.show"
              :title="uniAccredited.title"
              :type="uniAccredited.type"
              show-icon>
            </el-alert>
          </el-form-item>
          <el-form-item
            v-if="omotages.university && omotages.university[0].exName !== null && omotages.university[0].exName !== ''"
            label="Πρώην ονομασία: " size="small">
            {{ omotages.university[0].exName }}
          </el-form-item>
          <el-form-item
            v-if="omotages.university && omotages.university[0].comments !== null && omotages.university[0].comments !== ''"
            label="Παρατηρήσεις: " size="small">
            {{ omotages.university[0].exName }}
          </el-form-item>
          <el-form-item
            v-if="omotages.college && omotages.college.length > 0"
            label="Κολέγιο" size="small">
            {{application.titles.college.name}}
            <el-alert
              :closable="false"
              v-if="colAccredited.show"
              :title="colAccredited.title"
              :type="colAccredited.type"
              show-icon>
            </el-alert>
          </el-form-item>
          <el-form-item
            v-if="omotages.faculty && omotages.faculty.length > 0"
            label="Σχολή" size="small">
            {{application.titles.faculty.name}}
            <el-alert
              :closable="false"
              v-if="facAccredited.show"
              :title="facAccredited.title"
              :type="facAccredited.type"
              show-icon>
            </el-alert>
          </el-form-item>
          <el-form-item
            v-if="omotages.department && omotages.department.length > 0"
            label="Τμήμα" size="small">
            {{application.titles.department.name}}
            <el-alert
              :closable="false"
              v-if="depAccredited.show"
              :title="depAccredited.title"
              :type="depAccredited.type"
              show-icon>
            </el-alert>
          </el-form-item>
        </td>
        <td>
          <el-form-item v-if="application.titles.titleConsideration" label="Πανεπιστήμιο" size="small">
            {{application.titles.titleConsideration.university.name}}
            <el-alert
              :closable="false"
              v-if="conUniAccredited.show"
              :title="conUniAccredited.title"
              :type="conUniAccredited.type"
              show-icon>
            </el-alert>
          </el-form-item>
          <el-form-item
            v-if="application.titles.titleConsideration && omotagesConsideration.college && omotagesConsideration.college.length > 0"
            label="Κολέγιο" size="small">
            {{application.titles.titleConsideration.college.name}}
            <el-alert
              :closable="false"
              v-if="conColAccredited.show"
              :title="conColAccredited.title"
              :type="conColAccredited.type"
              show-icon>
            </el-alert>
          </el-form-item>
          <el-form-item
            v-if="application.titles.titleConsideration && omotagesConsideration.faculty && omotagesConsideration.faculty.length > 0"
            label="Σχολή" size="small">
            {{application.titles.titleConsideration.faculty.name}}
            <el-alert
              :closable="false"
              v-if="conFacAccredited.show"
              :title="conFacAccredited.title"
              :type="conFacAccredited.type"
              show-icon>
            </el-alert>
          </el-form-item>
          <el-form-item
            v-if="application.titles.titleConsideration && omotagesConsideration.department && omotagesConsideration.department.length > 0"
            label="Τμήμα" size="small">
            {{application.titles.titleConsideration.department.name}}
            <el-alert
              :closable="false"
              v-if="conDepAccredited.show"
              :title="conDepAccredited.title"
              :type="conDepAccredited.type"
              show-icon>
            </el-alert>
          </el-form-item>
          </td>
        </tr>
    </table>
    <div>
      <proposals></proposals>
      <internalComments></internalComments>
      <hr>
    </div>
    <!-- Παλιότερη όμοια πράξη ΝΑ ΓΙΝΕΙ ΑΝΕΞΑΡΤΗΤΟ COMPONENT-->
    <div v-if="!isReappraisal && !isPostExam">
      <el-form-item label="Παλιότερη πράξη" size="small" v-if="this.application.titles.college != null && this.application.titles.faculty != null && this.application.titles.department != null">
        <el-button size="small" type="primary" icon="el-icon-search" @click="getEquivalentActs() ; showSelectActs = true" :disabled='!isActiveBtn'>
          Αναζήτηση
        </el-button>
      </el-form-item>
      <el-form-item v-if="typeof (this.application.attachedDocuments.slice(0).find(step => step.type === 19)) !== 'undefined'">
        <el-alert
          title="Βρέθηκε σχετική πράξη παλιότερης αναγνώρισης και είναι συνημμένη στην καρτέλα Επισυναπτόμενα"
          :closable="false" type="success" show-icon>
        </el-alert>
      </el-form-item>
      <div v-if="selectedActFound === true">
        <el-form-item><span>Βρέθηκε παλιότερη πράξη με αριθμό: {{ this.selectedActNo }}
          και ημερομηνία: {{ this.selectedActDate }} <br> σύμφωνα με την οποία: {{ this.selectedActDecision }} ο τίτλος: {{ this.selectedActTitle }}</span>
        </el-form-item>
      </div>
      <br>
      <div>
        <el-form-item label="Ανέβασμα πράξης">
          <el-upload :disabled="!isActiveBtn" v-loading="this.addingAct"
            class="upload-demo"
            ref="uploadSimilarAct"
            accept=".pdf, .doc"
            :file-list="attachedSimilarAct"
            :http-request="addSimilarAct"
            action=""
            :on-remove="removeAct"
            :limit=1
            :auto-upload="true"
            :show-file-list="true">
            <el-button slot="trigger" size="small" type="primary" :disabled='!isActiveBtn'><i class="el-icon-upload el-icon-right"></i> Ανέβασμα</el-button>
            <div class="el-upload__tip" slot="tip" v-if="attachedSimilarAct.length === 0">** Μ Ο Ν Ο για να ανεβάσετε ένα αρχείο παλαιότερης όμοιας πράξης (pdf έως 12MB)</div>
          </el-upload>
        </el-form-item>
        <el-form-item>
          <el-dialog title="Παρόμοιες πράξεις" :visible.sync="showSelectActs" width="90%" v-loading="loadingEquivalentActs">
            <span v-if="!foundEquivalentActs">Δε βρέθηκαν παλιότερες πράξεις</span>
            <el-table v-if="foundEquivalentActs" :data="praxeis" style="width: 100%"  max-height="350">
              <el-table-column label="Αρ. πράξης" width="120">
                <template slot-scope="scope">
                  <span>{{ scope.row.PraxeisNo }}</span>
                </template>
              </el-table-column>
              <el-table-column label="Ημ/νια πράξης" width="120">
                <template slot-scope="scope">
                  <span>{{ scope.row.PraxeisDate.substring(0, 10) }}</span>
                </template>
              </el-table-column>
              <el-table-column label="Τίτλος" width="200">
                <template slot-scope="scope">
                  <span>{{ scope.row.certificationTitle }}</span>
                </template>
              </el-table-column>
              <el-table-column label="Απόφαση">
                <template slot-scope="scope">
                  <span>{{ scope.row.decision }}</span>
                </template>
              </el-table-column>
              <el-table-column label="Επιλογή" width="180">
                  <template slot-scope="scope">
                    <el-radio v-model="selectedAct"
                      :label='scope.row.PraxeisNo'
                      @change='selectedActChanged(scope.$index, scope.row)'>Επιλογή
                    </el-radio>
                  </template>
              </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
              <el-button @click="showSelectActs = false">Άκυρο</el-button>
              <el-button type="primary" :disabled="!foundEquivalentActs"
                @click="showSelectActs = false; selectedEquivalentAct(selectedActId)">Επιλογή
              </el-button>
            </span>
          </el-dialog>
        </el-form-item>
      </div>
    </div>
    <el-form-item label="Κατηγορία αίτησης" v-if="this.isReappraisal">
      <el-switch v-model="specialProponentJudgment.legalIssue" active-text="Νομικό ζήτημα" inactive-text="Ακαδημαϊκό ζήτημα"
        :disabled="fromReappraisalBoard">
      </el-switch>
    </el-form-item>
    <el-form-item label="Ενημ. σημείωμα" v-if="!fromReappraisalBoard">
      <vue-editor v-model='specialProponentJudgment.proposal' :editor-toolbar="customToolbar" class="propcolor"></vue-editor>
    </el-form-item>
    <el-form-item label="Υπολογισμός Τελικού Βαθμού" class="compact-form-item" v-if="isPostExam">
      <el-upload v-loading="this.uploadingFinalGrade"
        class="upload-demo"
        ref="uploadFinalGradeRef"
        accept=".pdf"
        :file-list="finalGradeAttachments"
        :http-request="addFinalGradeAttachment"
        :on-remove="handleFinalGradeRemove"
        :before-remove="handleBeforeRemove"
        :on-preview="viewPdf"
        action=""
        :limit=1
        :auto-upload="true"
        :show-file-list="true">
        <el-button slot="trigger" size="small" type="primary" :disabled="finalGradeAttachments.length >= 1">Ανέβασμα</el-button>
        <div class="el-upload__tip" slot="tip">** ΑΠΟΚΛΕΙΣΤΙΚΑ για ανέβασμα εγγράφου Υπολογισμού Τελικού Βαθμού (pdf έως 12MB)</div>
      </el-upload>
    </el-form-item>
    <el-form-item label="Δικαιολογητικό" v-if="!fromReappraisalBoard">
      <el-upload v-loading="this.uploadingAdditional"
        class="upload-demo"
        ref="uploadProponentRef"
        accept=".pdf"
        :file-list="proponentAttachments"
        :http-request="addAdditionalAttachment"
        :on-remove="handleAdditionalRemove"
        :before-remove="handleBeforeRemove"
        :on-preview="viewPdf"
        action=""
        :auto-upload="true"
        :show-file-list="true">
        <el-button slot="trigger" size="small" type="primary">Ανέβασμα</el-button>
        <div class="el-upload__tip" slot="tip">** ΑΠΟΚΛΕΙΣΤΙΚΑ για ανέβασμα επιπλέον δικαιολογητικού της αίτησης (pdf έως 12MB)</div>
      </el-upload>
    </el-form-item>
    <el-form-item label="Επισκόπηση Επανεξέτασης" v-if="fromReappraisalBoard">
      <el-upload v-loading="this.uploadingReappraisalOverview"
        class="upload-demo"
        ref="uploadReappraisalOverviewRef"
        accept=".pdf"
        :file-list="reappraisalOverviewAttachments"
        :http-request="addReappraisalOverviewAttachment"
        :on-remove="handleReappraisalOverviewRemove"
        :before-remove="handleBeforeRemove"
        :on-preview="viewPdf"
        :limit="1"
        action=""
        :auto-upload="true"
        :show-file-list="true">
        <el-button slot="trigger" size="small" type="primary" :disabled="reappraisalOverviewAttachments.length >= 1">Ανέβασμα</el-button>
        <div class="el-upload__tip" slot="tip">** ΑΠΟΚΛΕΙΣΤΙΚΑ για ανέβασμα Επισκόπησης της αίτησης Επανεξέτασης (pdf έως 12MB)</div>
      </el-upload>
    </el-form-item>
    <el-form-item label="Εσωτερικό Σχόλιο" v-if="!fromReappraisalBoard">
      <el-input type="textarea" class="internalComment" placeholder="Εισάγετε εσωτερικό σχόλιο"
        v-model="specialProponentJudgment.internalComment" size="100"
        :autosize="{ minRows: 4, maxRows: 10 }" @change="modifyInternalComment">
      </el-input>
    </el-form-item>
    <el-form-item label="Σχόλιο για Πολίτη" v-if="!fromReappraisalBoard && !isPostExam">
      <el-input type="textarea" class="citizenComment" placeholder="Εισάγετε σχόλιο για Πολίτη"
        v-model="specialProponentJudgment.pendingReason" size="100"
        :autosize="{ minRows: 4, maxRows: 10 }" @change="modifyPendingReason">
      </el-input>
    </el-form-item>
    <el-form-item label="Σχόλιο Αναδρομολόγησης" v-if='rerouteExists'>
      <el-input type="textarea" class="rerouteComment" placeholder="Εισάγετε σχόλιο για Πολίτη"
        v-model="rerouteCom" size="100" :disabled="true" :autosize="{ minRows: 4, maxRows: 10 }">
      </el-input>
    </el-form-item>
    <el-form-item label='Στην Αναμονή' v-if="!fromReappraisalBoard">
      <el-checkbox v-model='specialProponentJudgment.queue' @change='toggleQueue' label='Ναι' border=''>
      </el-checkbox>
    </el-form-item>
    <el-form-item label='Χρώμα' v-if="!fromReappraisalBoard">
      <el-input placeholder='Εισάγετε χρώμα' v-model='specialProponentJudgment.color'>
      </el-input>
    </el-form-item>
      <!-- <el-form-item label="Παραπομπή σε:">
        <el-select
          v-model="specialProponentJudgment.assignedTo.role"
          @change="toggleRole"
          filterable
          placeholder='Επιλογή Ρόλου'
        >
          <el-option v-show="showFromPresident"
            label="Πρόεδρος" value='ProcessViewer' key="1">
          </el-option>
          <el-option label="Αξιολογητής" value='AcademicConsultant' key="2">
          </el-option>
          <el-option label="Εκτελεστική Επιτροπή" value='ExecutiveBoardMember' key="3">
          </el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item v-if='loadingRoleMembers' label="Σύμβουλος">
        <el-select v-model="specialProponentJudgment.assignedTo.uid" filterable>
          <el-option v-for="user in usersToAssign" :key="user.id" :value="user.id" :label="user.surname + ' ' + user.firstname.substring(0,1) + '. (' + user.specialty.name + ')'">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="!fromReappraisalBoard">
        <el-tooltip class="item" effect="dark" placement="top">
          <div slot="content">
            Χρειάζεται απαραίτητα προσωρινή αποθήκευση της αίτησης πριν <br> προχωρήσετε στην αποδέσμευσή της αλλιώς όλα τα σχόλια <br> που προσθέσατε θα χαθούν.
          </div>
          <el-checkbox label='Επιθυμώ να αποδεσμεύσω την αίτηση' v-model='releaseChecked'>
          </el-checkbox>
        </el-tooltip>
      </el-form-item>
      <el-form-item v-if="!fromReappraisalBoard && !isPostExam">
        <el-tooltip class="item" effect="dark" placement="top">
          <div slot="content">
            Χρειάζεται απαραίτητα προσωρινή αποθήκευση της αίτησης <br> για να ανοίξει ο διάλογος
          </div>
          <el-checkbox label='Άνοιγμα διαλόγου με πολίτη' v-model='communicationActive'>
          </el-checkbox>
        </el-tooltip>
      </el-form-item>
      <!-- </div> -->
    <div style="text-align: center; padding-bottom: 10px;">
      <releaseButton
        v-if="!fromReappraisalBoard"
        releaseOrReroute="release"
        popoverContent="Είστε σίγουροι ότι θέλετε να την αποδεσμεύσετε στον προέλεγχο;
          Αν ναι το σχόλιο για τον λόγο της αποδέσμευσης είναι υποχρεωτικό!"
        tooltipContent="Η αίτηση θα επιστρέψει στον προέλεγχο"
        :releaseChecked="releaseChecked"
        :workingApplicationId="workingApplication.id"
        releaseByUser="specialProponent"
      >
      </releaseButton>
      <el-button v-if="!fromReappraisalBoard" size="mini" type="primary" round="" @click="tempSave" :disabled='false'>
        Προσωρινή Αποθήκευση
      </el-button>
      <el-button size="mini" type="danger" round="" @click="finalSave" :disabled='!isValidForm'>
        Οριστική Υποβολή
      </el-button>
    </div>
  </el-form>
</template>

<script>
import axios from 'axios'
import { mapState, mapGetters } from 'vuex'
import internalComments from '../common/internalComments'
import Proposals from '../common/Proposals'
import sharedMethods from '../common/sharedMethods.js'
import { VueEditor } from 'vue2-editor'
import releaseButton from '../base/releaseButton'

// Workaround for now as 18 get forbidden an file does not upload.
// On the receiving side we see 18 anyway. Should update this to 18
// When backend adds the document type.
const ATTACHMENT_TYPE_OTHER = 18
const ATTACHMENT_TYPE_REAPPRAISAL_OVERVIEW = 1016
const ATTACHMENT_TYPE_FINAL_GRADE = 2008

export default {
  components: {
    internalComments,
    Proposals,
    VueEditor,
    releaseButton
  },
  mixins: [sharedMethods],
  props: ['application', 'omotages', 'omotagesConsideration', 'roleName', 'usersToAssign', 'loadingRoleMembers', 'isReappraisal', 'isPostExam'],
  data () {
    return {
      communicationActive: false,
      releaseComment: '',
      customToolbar: [
        ['bold', 'italic', 'underline', 'strike'],
        // ['blockquote', 'code-block'],
        // [{ 'header': 1 }, { 'header': 2 }],
        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
        [{ 'indent': '-1' }, { 'indent': '+1' }],
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
        [{ 'color': [] }, { 'background': [] }],
        [{ 'align': [] }]
        // ['clean']
      ],
      selectedAct: '1',
      showSelectActs: false,
      selectedActId: null,
      modified: false,
      praxeis: [],
      selectedActFound: false,
      selectedActNew: true,
      found: 0,
      foundEquivalentActs: false,
      addingAct: false,
      uploading: false,
      uploadingFinalGrade: false,
      uploadingAdditional: false,
      uploadingReappraisalOverview: false,
      loadingEquivalentActs: false,
      releaseChecked: false
    }
  },
  methods: {
    gradeLabel () {
      if (this.isPostExam) {
        return 'Τελικός βαθμός (μετά από εξετάσεις)'
      }
      return 'Βαθμός πτυχίου'
    },
    gradeDescriptionLabel () {
      if (this.isPostExam) {
        return 'Χαρακτηρισμός (μετά από εξετάσεις)'
      }
      return 'Χαρακτηρισμός'
    },
    toggleQueue (val) {
    },
    setLabel (num) {
      return num
    },
    getEquivalentActs () {
      this.loadingEquivalentActs = true
      axios.get(
        `${this.BASE_URL}/equivalentAct/${this.workingApplication.id}`
      ).then((response) => {
        this.found = response.data.message.text[0]
        if (this.found !== 0) {
          this.foundEquivalentActs = true
        }
        this.praxeis = response.data.data.sort(function (a, b) {
          var dateA = new Date(a.PraxeisDate)
          var dateB = new Date(b.PraxeisDate)
          return dateB - dateA
        })
        this.praxeis.forEach(pr => { pr.selected = false })
        this.loadingEquivalentActs = false
      }, (err) => {
        this.backendError(err)
        this.loadingEquivalentActs = false
      })
    },
    selectedActChanged (selectedIndex, selectedRow) {
      this.praxeis.forEach(pr => { pr.selected = false })
      this.praxeis[selectedIndex].selected = true
      this.selectedActId = selectedRow.PraxeisId
      this.selectedActNo = selectedRow.PraxeisNo
      this.selectedActDate = selectedRow.PraxeisDate.substring(0, 10)
      this.selectedActDecision = selectedRow.decision
      this.selectedActTitle = selectedRow.certificationTitle
      if (selectedRow.file === false) {
        this.selectedActNew = false
      } else this.selectedActNew = true
    },
    selectedEquivalentAct (selectedActId) {
      this.selectedActFound = true
      this.selectedActId = selectedActId
      if (this.selectedActNew === true) {
        this.setSimilarAct(this.workingApplication.id, selectedActId)
      }
    },
    setSimilarAct (workingApplicationId, selectedActId) {
      if (this.selectedActNew === true) {
        axios.post(
          `${this.BASE_URL}/specialproponents/uid/similar_act`,
          {
            application: workingApplicationId,
            similarApplication: selectedActId
          }
        ).then((response) => {
          this.$store.dispatch('LOAD_WORKING_APPLICATION', workingApplicationId)
          this.frontEndSuccessMsg('Η σύνδεση της σχετικής πράξης πραγματοποιήθηκε')
        }).catch(() => {
          this.frontEndError('Δεν ήταν δυνατή η σύνδεση της σχετικής πράξης')
        })
      }
    },
    addSimilarAct (file, fileList) {
      this.addingAct = true
      return this.getData(file.file).then(data => {
        let payload = {
          type: 19,
          file: data,
          name: file.file.name,
          uuid: this.currentUser.id
        }
        return axios.post(
          `${this.BASE_URL}/users/${this.currentUser.id}/applications/${this.workingApplication.id}/attachments`,
          payload
        ).then(res => {
          let id = res.data.data.id
          file.file.id = id
          let similarActAttached = this.attachedSimilarAct.slice(0)
          similarActAttached[similarActAttached.length] = {type: payload.type, name: payload.name, uid: payload.uuid, id: id}
          this.$store.dispatch('SET_SIMILAR_ACT_ATTACHED', similarActAttached)
          this.addingAct = false
          this.frontEndSuccessMsg('Το ανέβασμα της παλιάς όμοιας πράξης ολοκληρώθηκε με επιτυχία και πλέον είναι διαθέσιμη στην καρτέλα Επισυναπτόμενα')
          // let similarActAttached = this.attachedSimilarAct.slice(0)
          // similarActAttached[similarActAttached.length] = {type: payload.type, name: payload.name, uid: payload.uuid, id: id}
          // this.$store.dispatch('SET_SIMILAR_ACT_ATTACHED', similarActAttached)
        }).catch((response) => {
          this.frontEndError('Σφάλμα κατά το ανέβασμα της παλιάς πράξης')
        })
      })
    },
    addFinalGradeAttachment (file, fileList) {
      this.addAttachment(file, ATTACHMENT_TYPE_FINAL_GRADE, this.finalGradeAttachments, 'SET_FINAL_GRADE_ATTACHMENTS',
        'uploadingFinalGrade', 'uploadFinalGradeRef')
    },
    addAdditionalAttachment (file, fileList) {
      this.addAttachment(file, ATTACHMENT_TYPE_OTHER, this.proponentAttachments, 'SET_PROPONENT_ATTACHMENTS',
        'uploadingAdditional', 'uploadProponentRef')
    },
    addReappraisalOverviewAttachment (file, fileList) {
      this.addAttachment(file, ATTACHMENT_TYPE_REAPPRAISAL_OVERVIEW, this.reappraisalOverviewAttachments, 'SET_REAPPRAISAL_OVERVIEW_ATTACHMENTS',
        'uploadingReappraisalOverview', 'uploadReappraisalOverviewRef')
    },
    addAttachment (file, attachmentType, attachmentsList, dispatchType, loading, uploadRef) {
      this[loading] = true
      return this.getData(file.file).then(data => {
        const url = `${this.BASE_URL}/users/${this.currentUser.id}/applications/${this.workingApplication.id}/attachments`
        let payload = {
          type: attachmentType,
          file: data,
          name: file.file.name,
          uuid: this.currentUser.id
        }
        return axios.post(url, payload)
          .then(res => {
            let id = res.data.data.id
            file.file.id = id
            this.frontEndSuccessMsg('Η προσθήκη του εγγράφου πραγματοποιήθηκε με επιτυχία')
            this[loading] = false
            let attachedDocs = attachmentsList.slice(0)
            attachedDocs[attachedDocs.length] =
              { type: payload.type, name: payload.name, uid: payload.uuid, id: id }
            this.$store.dispatch(dispatchType, attachedDocs)
            // this.$store.dispatch('LOAD_WORKING_APPLICATION', this.workingApplication.id)
          }).catch((err) => {
            this[loading] = false
            // Remove only the failed file from the el-upload list (not all files)
            if (uploadRef && this.$refs[uploadRef]) {
              this.$refs[uploadRef].uploadFiles = this.$refs[uploadRef].uploadFiles.filter(
                f => f.uid !== file.file.uid
              )
            }
            // Show a specific message for 413 (file too large), generic otherwise
            const errorMsg = err.response && err.response.status === 413
              ? 'Σφάλμα κατά την μεταφόρτωση του εγγράφου. Το αρχείο υπερβαίνει το επιτρεπτό μέγεθος (12MB).'
              : 'Σφάλμα κατά την μεταφόρτωση του εγγράφου.'
            this.frontEndError(errorMsg)
          })
      })
    },
    getData (file) {
      return new Promise((resolve, reject) => {
        const fReader = new FileReader()
        let base64Pdf
        fReader.onload = (fileLoadedEvent) => {
          base64Pdf = fileLoadedEvent.target.result
          resolve(base64Pdf.split(',')[1])
        }
        fReader.readAsDataURL(file)
      })
    },
    handleFinalGradeRemove (file, fileList) {
      this.handleRemove(file, this.finalGradeAttachments, 'SET_FINAL_GRADE_ATTACHMENTS', 'uploadingFinalGrade')
    },
    handleAdditionalRemove (file, fileList) {
      this.handleRemove(file, this.proponentAttachments, 'SET_PROPONENT_ATTACHMENTS', 'uploadingAdditional')
    },
    handleReappraisalOverviewRemove (file, fileList) {
      this.handleRemove(file, this.reappraisalOverviewAttachments, 'SET_REAPPRAISAL_OVERVIEW_ATTACHMENTS', 'uploadingReappraisalOverview')
    },
    handleRemove (file, attachmentsList, dispatchType, loading) {
      this[loading] = true
      const url = `${this.BASE_URL}/users/uid/applications/${this.workingApplication.id}/attachments/${file.id}`
      return axios.delete(url)
        .then(response => {
          this.frontEndSuccessMsg('Το έγγραφο αφαιρέθηκε')
          this[loading] = false
          this.$store.dispatch(dispatchType, attachmentsList.filter(attachment => attachment.id !== file.id))
        }).catch(err => {
          this.frontEndError('Σφάλμα κατά την αφαίρεση του εγγράφου')
          this.catchError(err)
          this[loading] = false
          // this.backendError(err)
          // throw err
        })
    },
    removeAct (file, fileList) {
      return axios.delete(
        `${this.BASE_URL}/users/${this.currentUser.id}/applications/${this.workingApplication.id}/attachments/${file.id}`
      ).then(response => {
        this.$store.dispatch('SET_SIMILAR_ACT_ATTACHED', [])
      }).catch(err => {
        this.$store.dispatch('SET_SIMILAR_ACT_ATTACHED', this.attachedSimilarAct)
        this.backendError(err)
        throw err
      })
    },
    handleBeforeRemove (file, fileList) {
      return this.$confirm(`Να αφαιρεθεί το ${file.name}？`)
    },
    viewPdf (file) {
      axios.get(`${this.BASE_URL}/users/uid/applications/${this.appId}/attachments/${file.id}`)
        .then((response) => {
          const base64Data = encodeURI(response.data.data.file[0])
          this.openPdfWindow(file.name + ' (' + file.id + ')', base64Data)
        })
    },
    catchError (err) {
      this.backendError(err)
      throw err
    },
    finalSave () {
      this.$confirm(this.saveMessage,
        'Προειδοποίηση', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Άκυρο',
          type: 'warning'
        })
        .then(() => {
          let roleTo = 'ProcessViewer'
          let theProposal = this.specialProponentJudgment.proposal
          let theInternalComment = this.specialProponentJudgment.internalComment
          if (this.fromReappraisalBoard) {
            roleTo = 'AcademicDirector'
            theProposal = null
            theInternalComment = null
          }
          let finalJudgment = {
            internalComment: theInternalComment,
            proposal: theProposal,
            pendingReason: this.specialProponentJudgment.pendingReason,
            queue: this.specialProponentJudgment.queue,
            color: this.specialProponentJudgment.color,
            grade: this.workingApplication.grade,
            certificationTitleByInternal: this.workingApplication.certificationTitleByInternal,
            assignedTo: {
              role: roleTo
            }
          }
          if (this.application.titles.titleConsideration) {
            finalJudgment = {
              ...finalJudgment,
              considerationTitleByInternal: this.workingApplication.considerationTitleByInternal || ''
            }
          }
          if (this.isReappraisal) {
            finalJudgment = {
              ...finalJudgment,
              legalIssue: this.specialProponentJudgment.legalIssue || false
            }
          }

          axios.put(
            `${this.BASE_URL}/specialproponents/uid/applications/${this.workingApplication.id}/final`,
            {
              judgment: finalJudgment
            }
          ).then((response) => {
            this.$store.dispatch('LOAD_ASSIGNED_APPLICATIONS', this.activeLane)
            this.frontEndSuccessMsg('Η αίτηση προωθήθηκε με επιτυχία')
          }).catch(err => {
            this.frontEndError('Σφάλμα κατά την οριστική αποθήκευση')
            this.catchError(err)
          })
        })
    },
    tempSave () {
      let finalJudgment = {
        communicationActive: this.communicationActive,
        internalComment: this.specialProponentJudgment.internalComment,
        proposal: this.specialProponentJudgment.proposal,
        pendingReason: this.specialProponentJudgment.pendingReason,
        queue: this.specialProponentJudgment.queue,
        color: this.specialProponentJudgment.color,
        grade: this.workingApplication.grade,
        certificationTitleByInternal: this.workingApplication.certificationTitleByInternal,
        assignedTo: {
          role: 'ProcessViewer'
        }
      }
      if (this.application.titles.titleConsideration) {
        finalJudgment = {
          ...finalJudgment,
          considerationTitleByInternal: this.workingApplication.considerationTitleByInternal || ''
        }
      }
      if (this.isReappraisal) {
        finalJudgment = {
          ...finalJudgment,
          legalIssue: this.specialProponentJudgment.legalIssue || false
        }
      }
      axios.put(
        `${this.BASE_URL}/specialproponents/uid/applications/${this.workingApplication.id}/temp`,
        {
          judgment: finalJudgment
        }
      ).then((response) => {
        this.$store.dispatch('LOAD_ASSIGNED_APPLICATIONS', this.activeLane)
        this.$store.dispatch('LOAD_WORKING_APPLICATION', this.workingApplication.id)
        this.frontEndSuccessMsg('Τα δεδομένα αποθηκεύτηκαν με επιτυχία')
      }).catch(err => {
        this.frontEndError('Σφάλμα κατά την προσωρινή αποθήκευση')
        this.catchError(err)
      })
    },
    modifyInternalComment (val) {
      this.modified = !(this.specialProponentJudgment.internalComment === this.internalComment)
    },
    modifyPendingReason (val) {
      this.modified = !(this.specialProponentJudgment.pendingReason === this.pendingReason)
    },
    toggleRole () {
      this.$emit('changedAssignedRole', this.specialProponentJudgment.assignedTo.role)
    },
    modifyCommunicationExternal () {
      const lastStep = this.workingApplication.applicationHistory.slice(-1)[0]
      if (
        ['proponentW_President', 'proponentW_Prechecker', 'proponentW_Board', 'proponentW_Admin']
          .includes(lastStep.applicationStatus)
      ) {
        this.communicationActive = lastStep.judgment.communicationActive || false
      }
    },
    findAcademicFieldByStatus (status) {
      const step = ((this.application && this.application.applicationHistory) || [])
        .slice()
        .reverse()
        .find(step => step.applicationStatus === status)

      return (step && step.judgment && step.judgment.academicField) || {}
    },

    getRelevantApplAcademicField () {
      return (
        this.workingApplication &&
        this.workingApplication.relevantAppl &&
        this.workingApplication.relevantAppl.academicField
      ) || {}
    },

    getPostExamAcademicField () {
      if (
        this.workingApplication &&
        this.workingApplication.relevantApplication &&
        this.workingApplication.relevantApplication.applicationType !== 'reappraisal'
      ) {
        return this.getRelevantApplAcademicField()
      }

      return (
        this.workingApplication &&
        this.workingApplication.relevantApplication &&
        this.workingApplication.relevantApplication.relevantAppl &&
        this.workingApplication.relevantApplication.relevantAppl.academicField
      ) || {}
    }
  },
  computed: {
    academicField () {
      if (this.showFromPresident) {
        return this.findAcademicFieldByStatus('presidentW_Prechecker')
      }

      if (this.showFromPrechecker) {
        if (this.isReappraisal) {
          return this.getRelevantApplAcademicField()
        }

        if (this.isPostExam) {
          return this.getPostExamAcademicField()
        }

        return this.findAcademicFieldByStatus('precheckerW_')
      }

      return {}
    },
    academicFieldName () {
      return this.academicField.name || ''
    },
    uniAccredited () {
      let recognizedMessage = 'Το ίδρυμα είναι αναγνωρισμένο'
      let notRecognizedMessage = 'Το ίδρυμα δεν αναγνωρίζεται'
      if (this.workingApplication.titles.university.isNewInstitute === 0) {
        recognizedMessage = 'Το ίδρυμα είναι ομοταγές'
        notRecognizedMessage = 'Το ίδρυμα δεν είναι ομοταγές'
      }
      let unAcc = this.omotages.university && this.omotages.university[0].accredited
      if (unAcc === 'yes') {
        return {title: recognizedMessage, type: 'success', show: true}
      } else if (unAcc === 'no') {
        return {title: notRecognizedMessage, type: 'error', show: true}
      } else if (unAcc === 'under investigation') {
        return {title: 'Μη κριθέν ίδρυμα', type: 'warning', show: true}
      } else if (unAcc === 'No data found for University.') {
        return {title: 'Δε βρέθηκαν στοιχεία για το συγκεκριμένο ίδρυμα', type: 'warning', show: true}
      } else {
        return {title: '', type: '', show: false}
      }
    },
    colAccredited () {
      let colAcc = this.omotages.college && this.omotages.college[0].accredited
      if (colAcc === 'yes') {
        return {title: 'Το κολέγιο είναι αναγνωρισμένο', type: 'success', show: true}
      } else if (colAcc === 'no') {
        return {title: 'Το κολέγιο δεν είναι αναγνωρισμένο', type: 'error', show: true}
      } else if (colAcc === 'under investigation') {
        return {title: 'Μη κριθέν κολέγιο', type: 'warning', show: true}
      } else {
        return {title: '', type: '', show: false}
      }
    },
    facAccredited () {
      let facAcc = this.omotages.faculty && this.omotages.faculty[0].accredited
      if (facAcc === 'yes') {
        return {title: 'Η σχολή είναι αναγνωρισμένη', type: 'success', show: true}
      } else if (facAcc === 'no') {
        return {title: 'Η σχολή δεν είναι αναγνωρισμένη', type: 'error', show: true}
      } else if (facAcc === 'under investigation') {
        return {title: 'Μη κριθείσα σχολή', type: 'warning', show: true}
      } else {
        return {title: '', type: '', show: false}
      }
    },
    depAccredited () {
      let depAcc = this.omotages.department && this.omotages.department[0].accredited
      if (depAcc === 'yes') {
        return {title: 'Το τμήμα είναι αναγνωρισμένο', type: 'success', show: true}
      } else if (depAcc === 'no') {
        return {title: 'Το τμήμα δεν είναι αναγνωρισμένο', type: 'error', show: true}
      } else if (depAcc === 'under investigation') {
        return {title: 'Μη κριθέν τμήμα', type: 'warning', show: true}
      } else {
        return {title: '', type: '', show: false}
      }
    },
    conUniAccredited () {
      let recognizedMessage = 'Το ίδρυμα είναι αναγνωρισμένο'
      let notRecognizedMessage = 'Το ίδρυμα δεν αναγνωρίζεται'
      if (this.workingApplication.titles.titleConsideration &&
        this.workingApplication.titles.titleConsideration.university &&
        this.workingApplication.titles.titleConsideration.university.isNewInstitute === 0) {
        recognizedMessage = 'Το ίδρυμα είναι ομοταγές'
        notRecognizedMessage = 'Το ίδρυμα δεν είναι ομοταγές'
      }
      let unAcc =
        this.omotagesConsideration &&
        this.omotagesConsideration.university &&
        this.omotagesConsideration.university[0].accredited
      if (unAcc === 'yes') {
        return {title: recognizedMessage, type: 'success', show: true}
      } else if (unAcc === 'no') {
        return {title: notRecognizedMessage, type: 'error', show: true}
      } else if (unAcc === 'under investigation') {
        return {title: 'Μη κριθέν ίδρυμα', type: 'warning', show: true}
      } else if (unAcc === 'No data found for University.') {
        return {title: 'Δε βρέθηκαν στοιχεία για το συγκεκριμένο ίδρυμα', type: 'warning', show: true}
      } else {
        return {title: '', type: '', show: false}
      }
    },
    conColAccredited () {
      let colAcc =
        this.omotagesConsideration &&
        this.omotagesConsideration.college &&
        this.omotagesConsideration.college[0].accredited
      if (colAcc === 'yes') {
        return {title: 'Το κολέγιο είναι αναγνωρισμένο', type: 'success', show: true}
      } else if (colAcc === 'no') {
        return {title: 'Το κολέγιο δεν είναι αναγνωρισμένο', type: 'error', show: true}
      } else if (colAcc === 'under investigation') {
        return {title: 'Μη κριθέν κολέγιο', type: 'warning', show: true}
      } else {
        return {title: '', type: '', show: false}
      }
    },
    conFacAccredited () {
      let facAcc =
        this.omotagesConsideration &&
        this.omotagesConsideration.faculty &&
        this.omotagesConsideration.faculty[0].accredited
      if (facAcc === 'yes') {
        return {title: 'Η σχολή είναι αναγνωρισμένη', type: 'success', show: true}
      } else if (facAcc === 'no') {
        return {title: 'Η σχολή δεν είναι αναγνωρισμένη', type: 'error', show: true}
      } else if (facAcc === 'under investigation') {
        return {title: 'Μη κριθείσα σχολή', type: 'warning', show: true}
      } else {
        return {title: '', type: '', show: false}
      }
    },
    conDepAccredited () {
      let depAcc =
        this.omotagesConsideration &&
        this.omotagesConsideration.department &&
        this.omotagesConsideration.department[0].accredited
      if (depAcc === 'yes') {
        return {title: 'Το τμήμα είναι αναγνωρισμένο', type: 'success', show: true}
      } else if (depAcc === 'no') {
        return {title: 'Το τμήμα δεν είναι αναγνωρισμένο', type: 'error', show: true}
      } else if (depAcc === 'under investigation') {
        return {title: 'Μη κριθέν τμήμα', type: 'warning', show: true}
      } else {
        return {title: '', type: '', show: false}
      }
    },
    historyReversed () {
      return this.application.applicationHistory.slice(0).reverse()
    },
    lastState () {
      return this.application.applicationHistory.slice(-1)[0].applicationStatus
    },
    rerouteCom () {
      const historyLast2 = this.application.applicationHistory.slice(-2)
      return historyLast2[1].applicationStatus === 'proponentW_Admin'
        ? historyLast2[0].rerouteComment
        : ''
    },
    rerouteExists () {
      return this.lastState === 'proponentW_Admin'
    },
    saveMessage () {
      let roleTo = this.roleName
      if (this.fromReappraisalBoard) {
        roleTo = 'τον Δ/ντή Ακαδ. Αναγνώρισης'
      }
      return 'Η αίτηση του/της ' + this.application.personalDetails.name +
        ' ' + this.application.personalDetails.surname + ' δρομολογείται προς ' + roleTo +
        '. Θέλετε να προχωρήσετε;'
    },
    isActiveBtn: function () {
      if (this.isReappraisal || this.isPostExam) {
        return false
      }
      if (this.application.titles.college.id === null || this.application.titles.faculty.id === null || this.application.titles.department.id === null) {
        return false
      }
      if (this.application.titles.titleConsideration && (this.application.titles.titleConsideration.college.id === null || this.application.titles.titleConsideration.faculty.id === null || this.application.titles.titleConsideration.department.id === null)) {
        return false
      }
      return true
    },
    isValidForm: function () {
      if (this.proposal === null || this.proposal.trim() === '') {
        return false
      }
      if (!this.isReappraisal && !this.isPostExam) {
        if (!this.workingApplication.certificationTitleByInternal ||
          this.workingApplication.certificationTitleByInternal.trim() === '') {
          return false
        }
        if (this.workingApplication.titles.titleConsideration && (!this.workingApplication.considerationTitleByInternal ||
          this.workingApplication.considerationTitleByInternal.trim() === '')) {
          return false
        }
        if (
          this.application.titles.university.isNewInstitute === 0 &&
          (this.application.titles.college.id === null ||
          this.application.titles.faculty.id === null ||
          this.application.titles.department.id === null)
        ) {
          return false
        }
        if (
          this.application.titles.titleConsideration &&
          this.application.titles.titleConsideration.university.isNewInstitute === 0 &&
          (
            this.application.titles.titleConsideration.college.id === null ||
            this.application.titles.titleConsideration.faculty.id === null ||
            this.application.titles.titleConsideration.department.id === null
          )
        ) {
          return false
        }
        if (
          this.specialProponentJudgment.assignedTo.role === 'AcademicConsultant' &&
          (
            this.specialProponentJudgment.assignedTo.uid === '' ||
            this.specialProponentJudgment.assignedTo.uid === null ||
            this.specialProponentJudgment.assignedTo.uid === undefined
          )
        ) {
          return false
        }
      }
      if (this.isReappraisal) {
        if (this.fromReappraisalBoard) {
          return this.reappraisalOverviewAttachments.length === 1
        }
      }
      if (this.isPostExam) {
        return this.application.grade && this.finalGradeAttachments.length === 1
      }
      return true
    },
    showFromAC () {
      return this.historyReversed.find(step => step.applicationStatus === 'boardW_Consultant')
    },
    showFrοmBoard () {
      return ['proponentW_Board'].includes(this.lastState)
    },
    showFromPresident () {
      return ['proponentW_President', 'proponentW_Admin'].includes(this.lastState)
    },
    showFromPrechecker () {
      return ['proponentW_Prechecker'].includes(this.lastState)
    },
    fromReappraisalBoard () {
      return ['proponentW_ReappraisalBoard'].includes(this.lastState)
    },
    fromConsultant () {
      return this.application.applicationHistory.slice().reverse()
        .find(item => item.applicationStatus === 'consultantW_Proponent') !== undefined
    },
    specialProponentJudgment () {
      return this.historyReversed
        .find(step =>
          ['proponentW_President', 'proponentW_Prechecker', 'proponentW_Admin', 'proponentW_Board'].includes(step.applicationStatus)
        ).judgment
    },
    proposal () {
      return this.specialProponentJudgment.proposal
    },
    internalComment () {
      return this.specialProponentJudgment.internalComment
    },
    presidentComment () {
      return this.historyReversed.find(
        step => step.applicationStatus === 'presidentW_Prechecker')
        .judgment.internalComment
    },
    consultantName () {
      return this.historyReversed
        .find(step => step.applicationStatus === 'consultantW_Proponent').user.name +
        ' ' +
        this.historyReversed
          .find(step => step.applicationStatus === 'consultantW_Proponent').user.surname
    },
    consultantJudgement () {
      return this.historyReversed
        .find(step => step.applicationStatus === 'consultantW_Proponent').judgment.proposal
    },
    boardJudgement () {
      return this.historyReversed
        .find(step =>
          step.applicationStatus === 'boardW_Proponent' ||
          step.applicationStatus === 'boardW_President' ||
          step.applicationStatus === 'boardW_Consultant')
        .judgment
    },
    appId () {
      this.modifyCommunicationExternal()
      return this.workingApplication.id
    },
    ...mapState([
      'workingApplication',
      'proponentAttachments',
      'finalGradeAttachments',
      'attachedSimilarAct',
      'internalComments',
      'proposals',
      'BASE_URL',
      'activeLane',
      'OVERDUE_MESSAGE',
      'reappraisalOverviewAttachments'
    ]),
    ...mapGetters({ currentUser: 'currentUser' })
  },
  watch: {
    appId: (newVal, oldVal) => {
    },
    pending: (newVal, oldVal) => {
      if (oldVal === true) this.comment = ''
    },
    comment: (newComment, oldComment) => {
      if (newComment === 'the reason for pending') this.comment = ''
    }
  }
}
</script>

<style scoped lang="scss">
.propcolor {
  background-color: #fff;
  font-weight: normal;
  padding: 1px;
}
.el-checkbox.is-bordered {
    padding: 9px 20px 9px 10px;
    border-radius: 4px;
    border: 1px solid #7da0b8;
}
.el-input {
  width: 240px;
}

.el-textarea {
  & > .el-textarea__inner {
    background-color:rgb(204, 118, 168);
  }
}

.citizenComment {
  background-color:#b7c1e1;
  padding: 1px;
  & > textarea {
    background-color:rgb(204, 118, 168);
  }
}

.rerouteComment {
  background-color:#f1959d;
  padding: 1px;
  & > textarea {
    background-color:rgb(204, 118, 168);
  }
}

.internalComment {
  background-color:#b7c1e1;
  padding: 1px;
  & > textarea {
    background-color:rgb(204, 118, 168);
  }
}

.el-checkbox__label {
  background-color: transparent;
}

.el-form-item__content {
  line-height: 20px;
}
.el-form-item__label {
    text-align: right;
    float: left;
    font-size: 14px;
    color: #606266;
    line-height: 20px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}
.agree-btn {
    background-color: #67c23a;
    border-radius: 20px;
    color: #fff;
    display: inline-block;
    font-size: 14px;
    height: 26px;
    line-height: 26px;
    padding: 0 6px;
    text-align: center;
    white-space: nowrap;
    border: 1px solid #fff;
}
.disagree-btn {
    background-color: red;
    border-radius: 20px;
    color: #fff;
    display: inline-block;
    font-size: 14px;
    height: 26px;
    line-height: 26px;
    padding: 0 6px;
    text-align: center;
    white-space: nowrap;
    border: 1px solid #fff;
}
.done-btn {
    background-color: #67c23a;
    border-radius: 20px;
    color: #fff;
    display: inline-block;
    font-size: 14px;
    height: 26px;
    line-height: 26px;
    padding: 0 6px;
    text-align: center;
    white-space: nowrap;
    border: 1px solid #fff;
}
.pending-btn {
    background-color: orange;
    border-radius: 20px;
    color: #fff;
    display: inline-block;
    font-size: 14px;
    height: 26px;
    line-height: 26px;
    padding: 0 6px;
    text-align: center;
    white-space: nowrap;
    border: 1px solid #fff;
}
hr {
  border-color: #7da0b8;
}
.el-alert {
  background-color: unset;
  font-style: normal;
  text-align:left;
  display: inline;
}
.text-red {
  font-style:normal;
  color:crimson;
}
.el-form-item {
  color: rgb(30, 0, 128);
  font-weight: bold;
  // border-radius: 10px;
  // border-style: solid;
  // border-color: #7fa3bb green #86b8da yellow;
  // border-width: 0px 0px 2px 0px;
  // border: 2px 0px 0px 0px solid #7fa3bb;
  padding-right: 20px;
  padding-left: 10px;
}
.el-card {
  background-color: inherit;
}
</style>



// WEBPACK FOOTER //
// src/components/roleSpecific/SpecialProponentJudgment.vue